import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '../sass/main.scss';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#40108e',
        secondary: '#1EE8B8',
        tertiary: '#F8DCCC'
      },
    },
  },
});
